/**
 * mcycle step finish module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/28
 */
import React from 'react';

const FinishRow = ({title, message}) => {
  return <li>
    <p className="mcycle-step-info-item">{ title }</p>
    <p className="mcycle-step-info-value">{ message }</p>
  </li>
}

export default FinishRow


// WEBPACK FOOTER //
// ./src/components/step3/finish/finishRow.js